"use client";

import { c as _c } from "react/compiler-runtime";
import { signIn } from "@/actions/auth";
import PasswordField from "@/components/PasswordField";
import { Button, Checkbox, Divider, FormControlLabel, Link, Paper, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { memo, useActionState, useEffect, useState, startTransition } from "react";
const LoginForm = memo(function LoginForm() {
  const $ = _c(52);
  const router = useRouter();
  const [rememberMe, setRememberMe] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [errors, setErrors] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [state, action, isPending] = useActionState(signIn, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (field, isError, message) => {
      setErrors(prev => ({
        ...prev,
        [field]: {
          isError,
          message
        }
      }));
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setFieldError = t2;
  let t3;
  if ($[3] !== rememberMe) {
    t3 = async e => {
      e.preventDefault();
      let hasError = false;
      const formData = new FormData(e.currentTarget);
      formData.append("rememberMe", rememberMe);
      const data = Object.fromEntries(formData.entries());
      const validateField = (field_0, value, label) => {
        if (!value || String(value).trim() === "") {
          setFieldError(field_0, true, `${label} is required`);
          hasError = true;
        } else {
          setFieldError(field_0, false, "");
        }
      };
      validateField("username", data.username, "Username");
      validateField("password", data.password, "Password");
      if (hasError) {
        return;
      }
      startTransition(() => {
        action({
          username: data.username,
          password: data.password
        });
      });
    };
    $[3] = rememberMe;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleSubmit = t3;
  let t4;
  if ($[5] !== state?.error) {
    t4 = () => {
      if (state?.error) {
        setFieldError("username", true, "Invalid username or password");
        setFieldError("password", true, "Invalid username or password");
      }
    };
    $[5] = state?.error;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = state?.error;
  const t6 = state?.timestamp;
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = [t5, t6];
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  useEffect(t4, t7);
  let t8;
  if ($[10] !== router || $[11] !== state) {
    t8 = () => {
      if (state?.id) {
        const {
          type
        } = state;
        if (type === "admin") {
          router.push("/admin/dashboard");
        } else {
          if (type === "student") {
            router.push("/student/modules");
          } else {
            if (type === "teacher") {
              router.push("/teacher/classes");
            } else {
              router.push("/dashboard");
            }
          }
        }
      }
    };
    $[10] = router;
    $[11] = state;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = state?.id;
  let t10;
  if ($[13] !== t9) {
    t10 = [t9];
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  useEffect(t8, t10);
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      p: 4,
      borderRadius: 4,
      m: {
        xs: 1,
        md: 0
      }
    };
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      display: "flex",
      justifyContent: {
        xs: "center",
        md: "space-between"
      },
      mb: 1
    };
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      display: "flex",
      flexDirection: "column"
    };
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Typography variant="h5" sx={{
      fontWeight: 700,
      color: "primary.main"
    }}>Hi, Welcome Back</Typography>;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Box sx={t12}><Box sx={t13}>{t14}<Typography variant="body1" sx={{
          color: "text.secondary",
          fontWeight: 700
        }}>Login in to your account</Typography></Box><Image src="/images/logos/green.png" height={50} width={50} alt="Logo" /></Box>;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      mb: 1
    };
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  const t17 = errors.username?.isError;
  const t18 = errors.username?.message;
  let t19;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      inputLabel: {
        shrink: true
      }
    };
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  let t20;
  if ($[22] !== t17 || $[23] !== t18) {
    t20 = <TextField label="Username" variant="outlined" fullWidth={true} margin="normal" name="username" error={t17} helperText={t18} slotProps={t19} />;
    $[22] = t17;
    $[23] = t18;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  const t21 = errors.password?.isError;
  const t22 = errors.password?.message;
  let t23;
  if ($[25] !== t21 || $[26] !== t22) {
    t23 = <PasswordField error={t21} helperText={t22} />;
    $[25] = t21;
    $[26] = t22;
    $[27] = t23;
  } else {
    t23 = $[27];
  }
  let t24;
  if ($[28] !== t20 || $[29] !== t23) {
    t24 = <Box sx={t16}>{t20}{t23}</Box>;
    $[28] = t20;
    $[29] = t23;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  let t25;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    };
    $[31] = t25;
  } else {
    t25 = $[31];
  }
  let t26;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = e_0 => setRememberMe(e_0.target.checked);
    $[32] = t26;
  } else {
    t26 = $[32];
  }
  let t27;
  if ($[33] !== rememberMe) {
    t27 = <Checkbox color="primary" checked={rememberMe} size="small" onChange={t26} />;
    $[33] = rememberMe;
    $[34] = t27;
  } else {
    t27 = $[34];
  }
  let t28;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      typography: {
        variant: "subtitle2"
      }
    };
    $[35] = t28;
  } else {
    t28 = $[35];
  }
  let t29;
  if ($[36] !== t27) {
    t29 = <Box><FormControlLabel control={t27} label="Remember me" slotProps={t28} /></Box>;
    $[36] = t27;
    $[37] = t29;
  } else {
    t29 = $[37];
  }
  let t30;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <Link href="#" variant="subtitle2" underline="hover">Forgot password?</Link>;
    $[38] = t30;
  } else {
    t30 = $[38];
  }
  let t31;
  if ($[39] !== t29) {
    t31 = <Box sx={t25}>{t29}{t30}</Box>;
    $[39] = t29;
    $[40] = t31;
  } else {
    t31 = $[40];
  }
  let t32;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      my: 2
    };
    $[41] = t32;
  } else {
    t32 = $[41];
  }
  const t33 = isPending ? "Signing In..." : "Sign In";
  let t34;
  if ($[42] !== isPending || $[43] !== t33) {
    t34 = <Box sx={t32}><Button variant="contained" color="primary" fullWidth={true} type="submit" disabled={isPending}>{t33}</Button></Box>;
    $[42] = isPending;
    $[43] = t33;
    $[44] = t34;
  } else {
    t34 = $[44];
  }
  let t35;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <Divider />;
    $[45] = t35;
  } else {
    t35 = $[45];
  }
  let t36;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <Link href="#" variant="subtitle2" underline="none" color="black" sx={{
      display: "block",
      width: "fit-content",
      ml: "auto",
      mt: 2,
      fontWeight: 500
    }}>Don't have an account?</Link>;
    $[46] = t36;
  } else {
    t36 = $[46];
  }
  let t37;
  if ($[47] !== handleSubmit || $[48] !== t24 || $[49] !== t31 || $[50] !== t34) {
    t37 = <Paper sx={t11} component="form" noValidate={true} autoComplete="off" onSubmit={handleSubmit}>{t15}{t24}{t31}{t34}{t35}{t36}</Paper>;
    $[47] = handleSubmit;
    $[48] = t24;
    $[49] = t31;
    $[50] = t34;
    $[51] = t37;
  } else {
    t37 = $[51];
  }
  return t37;
});
export default LoginForm;